"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: credit-report/detailed-report.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcredit-report%2Fdetailed-report.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.Account = exports.DetailedReport = void 0;
const amount_1 = require("../common/amount");
const date_1 = require("../common/date");
const protobufPackage = 'com.step.creditreport.insight.report.proto';
function createBaseDetailedReport() {
    return { reportId: '', accounts: [], hasStepAccount: false };
}
exports.DetailedReport = {
    fromJSON(object) {
        const message = {
            reportId: isSet(object.reportId) ? globalThis.String(object.reportId) : '',
            hasStepAccount: isSet(object.hasStepAccount)
                ? globalThis.Boolean(object.hasStepAccount)
                : false,
        };
        if (globalThis.Array.isArray(object?.accounts)) {
            message.accounts = object.accounts.map((e) => exports.Account.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.reportId !== '') {
            obj.reportId = message.reportId;
        }
        if (message.accounts?.length) {
            obj.accounts = message.accounts.map((e) => exports.Account.toJSON(e));
        }
        if (message.hasStepAccount !== false) {
            obj.hasStepAccount = message.hasStepAccount;
        }
        return obj;
    },
    create(base) {
        return exports.DetailedReport.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDetailedReport();
        message.reportId = object.reportId ?? '';
        message.accounts = object.accounts?.map((e) => exports.Account.fromPartial(e)) || [];
        message.hasStepAccount = object.hasStepAccount ?? false;
        return message;
    },
};
function createBaseAccount() {
    return {
        reportingSubscriberName: '',
        effectiveDate: date_1.LocalDate.fromPartial({}),
        closedDate: undefined,
        currentBalanceAmount: undefined,
    };
}
exports.Account = {
    fromJSON(object) {
        const message = {
            reportingSubscriberName: isSet(object.reportingSubscriberName)
                ? globalThis.String(object.reportingSubscriberName)
                : '',
            effectiveDate: isSet(object.effectiveDate)
                ? date_1.LocalDate.fromJSON(object.effectiveDate)
                : date_1.LocalDate.fromPartial({}),
        };
        if (isSet(object.closedDate)) {
            message.closedDate = date_1.LocalDate.fromJSON(object.closedDate);
        }
        if (isSet(object.currentBalanceAmount)) {
            message.currentBalanceAmount = amount_1.Amount.fromJSON(object.currentBalanceAmount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.reportingSubscriberName !== '') {
            obj.reportingSubscriberName = message.reportingSubscriberName;
        }
        if (message.effectiveDate !== undefined) {
            obj.effectiveDate = date_1.LocalDate.toJSON(message.effectiveDate);
        }
        if (message.closedDate !== undefined) {
            obj.closedDate = date_1.LocalDate.toJSON(message.closedDate);
        }
        if (message.currentBalanceAmount !== undefined) {
            obj.currentBalanceAmount = amount_1.Amount.toJSON(message.currentBalanceAmount);
        }
        return obj;
    },
    create(base) {
        return exports.Account.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccount();
        message.reportingSubscriberName = object.reportingSubscriberName ?? '';
        message.effectiveDate = (object.effectiveDate !== undefined && object.effectiveDate !== null)
            ? date_1.LocalDate.fromPartial(object.effectiveDate)
            : date_1.LocalDate.fromPartial({});
        message.closedDate = (object.closedDate !== undefined && object.closedDate !== null)
            ? date_1.LocalDate.fromPartial(object.closedDate)
            : undefined;
        message.currentBalanceAmount =
            (object.currentBalanceAmount !== undefined && object.currentBalanceAmount !== null)
                ? amount_1.Amount.fromPartial(object.currentBalanceAmount)
                : undefined;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=detailed-report.js.map